import {
  getIndexDetailDatas,
  getLevelList,
  getMessageSource,
  getIndexHeadDatas,
  getMemberRangeDatas,
  getMemberRecRangeDatas,
  getMemberRecAuditRangeDatas,
  getMemberFollowRangeDatas,
  getDevOverView,
  getRecOverView,
  getRecAuditOverView,
  getDTendencyDatas,
  getRTendencyDatas,
  getRAuditTendencyDatas,
  getFollowDataOverview,
  getDevDistributeDatas,
  getFollowTendencyDatas,
  getDetailTableDatas,
  getExportLinkUrl,
  getIndexFilterDatas,
  getFollowDetailTableDatas,
  getDetailRecTableDatas,
  getStaticType,
  getDetailTableDatasPc,
  getDetailRecTablePcDatas,
  getDetailRecFromInfoPcDatas,
  getDetailRecAuditTablePcDatas,
  getDetailRecAuditTableMobileDatas,
  getRecStatisticPermission
} from '@/services/statistic'
import { permissionMenu } from '@/services'
import i18n from '@/lib/language'
import { isMobile } from '@/lib/device'
const mobileItemList = [
  { text: i18n.t('message["1671"]'), value: '1' },
  { text: i18n.t('message["1369"]'), value: '2' },
  { text: i18n.t('message["1368"]'), value: '3' },
  { text: i18n.t('message["1364"]'), value: '4' }
]

export default {
  namespaced: true,
  state: {
    // 移动端
    viewPages: null, // 首页选择
    formateRangeDatasStatus: false, // 是否展示范围选择框
    infoTypeLists: null, // 移动端信息分类
    mobileItemList, // 移动端首页选择项目
    followFilterDataList: [], // 信息跟进筛选列表
    followFilterDataDetailList: [], // 信息跟进筛选列表
    permissionMenuList: null, // menu列表
    memberSelectVisible: false, // 成员选择状态
    // PC端
    checkParams: null, // 数据统计首页筛选数据参数
    followTablesDetailDatas: null, // 跟进详细数据
    recTablesDetailDatas: null, // 跟进详细数据
    confirmLoading: false, // 筛选确定loading
    checkVisible: false, // 筛选Dialog
    loadingContent: true, // 加载动画
    levelList: [], // 分级列表
    indexDetailDatas: [], // 首页详细数据
    indexExportLinkUrl: '', // 首页导出链接
    messageSourceList: [], // 信息来源数据
    indexHeadDatas: {}, // 顶部概览数据
    memberRangeDatas: [], // 顶部范围数据
    memberRangeDefaultDatas: [], // 顶部范围默认值
    devRecOverViewDatas: [], // 开发接待概览数据
    tendencyDataArray: [], // 开发接待趋势数据
    followOverviewDatas: [], // 跟进概览数据
    devDistributeDatas: {}, // 开发分布数据
    tendencyFollowDatas: [], // 跟进趋势数据
    detailTableDatas: [], // 开发-跟进-接待详细数据
    indexFilterDatas: {}, // 首页过滤数据信息
    staticType: [], // 数据类型,
    staticTypeRecord: {},
    fromDatas: [], // 信息类型数据,
    newFromDatas: [], // 筛选后的信息类型,
    isTablePShow: false,
    receptionType: 'createSta', // 接待统计类型
    fromSelectData: [], // 录入统计数据模块，信息来源筛选
    isRecMobileDataReady: false,
    recStatisticPermission: {
      // 'inquiry-add': true,
      // 'inquiry-audit': true
    }, // 信息接待统计页面-录入统计/审核统计权限
    rowKeysReady: true
  },
  mutations: {
    // 移动端
    setMemberSelectVisible (state, data) {
      state.memberSelectVisible = data
    },
    setFormateRangeDatasStatus (state, data) {
      state.formateRangeDatasStatus = data
    },
    setViewPages (state, data) {
      state.viewPages = data
    },
    setPermissionMenuList (state, data) {
      state.permissionMenuList = data
    },
    setInfoTypeLists (state, data) {
      state.infoTypeLists = data
    },
    setFollowFilterDataList (state, data) {
      state.followFilterDataList = data
    },
    setFollowFilterDataDetailList (state, data) {
      state.followFilterDataDetailList = data
    },
    // PC端
    setConfirmLoading (state, data) {
      state.confirmLoading = data
    },
    setFollowTablesDetailDatas (state, data) {
      state.followTablesDetailDatas = data
    },
    setCheckParams (state, data) {
      state.checkParams = data
    },
    setRecTablesDetailDatas (state, data) {
      state.recTablesDetailDatas = data
    },
    // 设置分级列表
    setLevelList (state, data) {
      state.levelList = data
    },
    setCheckVisible (state, data) {
      state.checkVisible = data
    },
    // 设置信息来源列表
    setMessageSourceList (state, data) {
      state.messageSourceList = data
    },
    // 设置首页详细数据
    setIndexDetailDatas (state, data) {
      state.indexDetailDatas = data
    },
    // 设置顶部概览数据
    setIndexHeadDatas (state, data) {
      state.indexHeadDatas = data
    },
    // 设置顶部范围数据
    setMemberRangeDatas (state, data) {
      state.memberRangeDatas = data
    },
    // 设置顶部范围默认数据
    setMemberRangeDefaultDatas (state, data) {
      state.memberRangeDefaultDatas = data
    },
    // 设置信息开发跟进概览数据
    setDevRecOverViewDatas (state, data) {
      state.devRecOverViewDatas = data
    },
    // 设置开发跟进趋势数据
    setTendencyDataArray (state, data) {
      state.tendencyDataArray = data
    },
    // 设置跟进概览数据
    setFollowOverviewDatas (state, data) {
      state.followOverviewDatas = data
    },
    // 设置开发分布数据
    setDevDistributeDatas (state, data) {
      state.devDistributeDatas = data
    },
    // 设置跟进趋势数据
    setTendencyFollowDatas (state, data) {
      state.tendencyFollowDatas = data
    },
    // 设置开发-跟进-接待详细数据
    setDetailTableDatas (state, data) {
      state.detailTableDatas = data
    },
    // 设置首页导出链接
    setGetExportLinkUrl (state, data) {
      state.indexExportLinkUrl = data
    },
    // 设置首页筛选信息数据
    setIndexFilterDatas (state, data) {
      state.indexFilterDatas = data
    },
    setLoadingContent (state, data) {
      state.loadingContent = data
    },
    setStaticType (state, list) {
      state.staticType = ([{ id: 0, name: i18n.t('message["907"]') }].concat(list)).map(item => {
        return { id: item.id, 'name': item.name }
      })
    },
    // pc端设置staticTypeRecord 数据类型备案等
    setStaticTypeRecord (state, data) {
      state.staticTypeRecord = data
    },
    setFromDatas (state, data) {
      state.fromDatas = data
    },
    setNewFromDatas (state, data) {
      state.newFromDatas = data
    },
    setIsTablePShow (state, b) {
      state.isTablePShow = b
    },
    // 设置接待统计类型
    setReceptionType (state, type) {
      state.receptionType = type
    },
    setFromSelectData (state, data) {
      state.fromSelectData = data
    },
    setIsRecMobileDataReady (state, b) {
      state.isRecMobileDataReady = b
    },
    SET_REC_STATISTIC_PERMISSION (state, data) {
      state.recStatisticPermission = data
    },
    seIsRowKeysReady (state, b) {
      state.rowKeysReady = b
    }
  },
  getters: {
    staticTypeList (state) {
      const { staticTypeRecord } = state
      const obj = {}
      for (let key in staticTypeRecord) {
        if (key === 'info_sign') {
          obj['info_sign'] = staticTypeRecord['info_sign'].options
          obj['info_sign_status'] = staticTypeRecord['info_sign'].status
        }
        if (key === 'info_type') {
          obj['info_type'] = ([{ id: 0, name: i18n.t('message["907"]') }].concat(staticTypeRecord['info_type'].options)).map(item => {
            return { id: item.id, 'name': item.name }
          })
        }
      }
      // console.log(obj)
      return obj
    },
    memberRangeDefaultObj (state) {
      let obj = {}
      state.memberRangeDefaultDatas.forEach(item => {
        let one = item.split('-')
        obj[one[0]] = one[1]
      })
      return obj
    }
  },
  actions: {
    // 获取分级列表方法
    async fetchGetLevelList ({ rootState, commit }) {
      const chain = await getLevelList()
        .onSuccess(payload => {
          commit('setLevelList', payload)
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取信息来源数据
    async fetchGetMessageSource ({ rootState, commit }) {
      const chain = await getMessageSource()
        .onSuccess(payload => {
          commit('setMessageSourceList', payload)
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取列表数据
    async fetchGetPermissionMenu ({ rootState, commit }) {
      const chain = await permissionMenu()
        .onSuccess(payload => {
          commit('setPermissionMenuList', payload)
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取首页筛选信息
    async fetchGetIndexFilterDatas ({ commit }) {
      const chain = await getIndexFilterDatas()
        .onSuccess(payload => {
          commit('setIndexFilterDatas', payload)
          commit('setLoadingContent', false)
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取首页导出链接
    async fetchGetExportLinkUrl ({ commit }, params) {
      const chain = await getExportLinkUrl()
        .onSuccess(payload => {
          commit('setGetExportLinkUrl', payload)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取首页筛选信息数据方法
    // 获取首页详细数据
    async fetchGetIndexDetailDatas ({ commit }, params) {
      const chain = await getIndexDetailDatas()
        .onSuccess(payload => {
          commit('setConfirmLoading', false)
          commit('setCheckVisible', false)
          commit('setIndexDetailDatas', payload)
          commit('setLoadingContent', false)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },

    async fetchGetIndexHeadDatas ({ commit }, params) {
      const chain = await getIndexHeadDatas()
        .onSuccess(payload => {
          commit('setIndexHeadDatas', payload)
          commit('setLoadingContent', false)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    async fetchGetMemberRangeDatas ({ dispatch, commit }) {
      const chain = await getMemberRangeDatas()
        .onSuccess(payload => {
          commit('setMemberRangeDatas', payload.data)
          if (payload.defaulvalue) {
            // console.log(payload.defaulvalue)
            dispatch('formateRangeDatas', payload.defaulvalue)
          }
          commit('setFormateRangeDatasStatus', payload.showNav)
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // member
    async fetchGetMemberRecRangeDatas ({ dispatch, commit, state }) {
      let chain = null
      if (state.receptionType === 'createSta') {
        chain = await getMemberRecRangeDatas()
      } else {
        chain = await getMemberRecAuditRangeDatas()
      }

      chain.onSuccess(payload => {
        commit('setMemberRangeDatas', payload.data)
        if (payload.defaulvalue) {
          dispatch('formateRangeDatas', payload.defaulvalue)
        }
        commit('setFormateRangeDatasStatus', payload.showNav)
      })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    async fetchGetMemberFollowRangeDatas ({ dispatch, commit }) {
      const chain = await getMemberFollowRangeDatas()
        .onSuccess(payload => {
          commit('setMemberRangeDatas', payload.data)
          if (payload.defaulvalue) {
            dispatch('formateRangeDatas', payload.defaulvalue)
          }
          commit('setFormateRangeDatasStatus', payload.showNav)
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    formateRangeDatas ({ commit }, data) {
      let temp = []
      if (Array.isArray(data)) {
        data.map(value => {
          temp.push(`${value.keyname}-${value.id}`)
          // if (index === 0) {
          //   value = `roleid-${value}`
          // } else if (index === 1) {
          //   value = `groupid-${value}`
          // } else {
          //   value = `userid-${value}`
          // }
          // temp[index] = value
        })
        commit('setMemberRangeDefaultDatas', temp)
        commit('setLoadingContent', false)
      }
    },
    async fetchGetDevRecOverView ({ commit, state }, params) {
      const chain = await getDevOverView()
        .onSuccess(payload => {
          commit('setDevRecOverViewDatas', payload)
          commit('setLoadingContent', false)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // view
    async fetchGetRecOverView ({ commit, state }, params) {
      let chain = null
      commit('setIsRecMobileDataReady', false)
      if (state.receptionType === 'createSta') {
        chain = await getRecOverView()
      } else {
        chain = await getRecAuditOverView()
      }
      chain.onSuccess(payload => {
        commit('setDevRecOverViewDatas', payload)
        commit('setLoadingContent', false)
        commit('setIsRecMobileDataReady', true)
      })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    async fetchGetDTendencyDatas ({ commit }, params) {
      const chain = await getDTendencyDatas()
        .onSuccess(payload => {
          commit('setTendencyDataArray', payload)
          commit('setLoadingContent', false)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // trend
    async fetchGetRTendencyDatas ({ commit, state }, params) {
      let chain = null
      if (state.receptionType === 'createSta') {
        chain = await getRTendencyDatas()
      } else {
        chain = await getRAuditTendencyDatas()
      }
      chain.onSuccess(payload => {
        commit('setTendencyDataArray', payload)
        commit('setLoadingContent', false)
      })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    async fetchGetFollowDataOverview ({ commit }, params) {
      const chain = await getFollowDataOverview()
        .onSuccess(payload => {
          commit('setFollowOverviewDatas', payload)
          commit('setLoadingContent', false)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    async fetchDevDistributeDatas ({ commit }, params) {
      const chain = await getDevDistributeDatas()
        .onSuccess(payload => {
          commit('setDevDistributeDatas', payload)
          commit('setLoadingContent', false)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    async fetchGetFollowTendencyDatas ({ commit }, data) {
      const chain = await getFollowTendencyDatas()
        .onSuccess(payload => {
          commit('setTendencyFollowDatas', payload)
          commit('setLoadingContent', false)
        })
        .params({
          ...data
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    async fetchGetDetailTableDatas ({ commit }, data) {
      commit('seIsRowKeysReady', false)
      const chain = await isMobile ? getDetailTableDatas() : getDetailTableDatasPc()
      chain.onSuccess(payload => {
        commit('setDetailTableDatas', payload)
        commit('setLoadingContent', false)
        commit('seIsRowKeysReady', true)
      })
        .params({
          ...data
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    async fetchGetFollowDetailTableDatas ({ commit }, params) {
      const chain = await getFollowDetailTableDatas()
        .onSuccess(payload => {
          commit('setFollowTablesDetailDatas', payload)
          commit('setLoadingContent', false)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // detail detailt
    async fetchGetRecDetailTableDatas ({ commit, state }, params) {
      commit('seIsRowKeysReady', false)
      let chain = null
      const { receptionType } = state
      if (isMobile) {
        // commit('setLoadingContent', true)
        if (receptionType === 'createSta') {
          chain = await getDetailRecTableDatas()
        } else {
          chain = await getDetailRecAuditTableMobileDatas()
        }
      } else {
        if (receptionType === 'createSta') {
          chain = await getDetailRecTablePcDatas()
        } else {
          chain = await getDetailRecAuditTablePcDatas()
        }
      }

      chain.onSuccess(payload => {
        commit('setRecTablesDetailDatas', payload)
        commit('setLoadingContent', false)
        commit('seIsRowKeysReady', true)
      })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    async fetchStaticTypes ({ commit, state }) {
      const chain = await getStaticType()
        .onSuccess(payload => {
          if (isMobile) {
            commit('setStaticType', payload)
          } else {
            commit('setStaticTypeRecord', payload)
          }
        })
        .params({ fieldkey: 'info_type', issign: isMobile ? 0 : 1 })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // getFrom
    async  getDetailRecFromInfoPcDatas ({ commit, state }, data) {
      const chain = await getDetailRecFromInfoPcDatas()
        .onSuccess(payload => {
          commit('setFromSelectData', payload)
        })
        .params(data)
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    async fetchRecStatisticPermission ({ commit, state }, data) {
      const chain = await getRecStatisticPermission()
      chain.onSuccess(payload => {
        commit('SET_REC_STATISTIC_PERMISSION', payload)
      })
        .params(data)
        .config({
          tip: false
        })
        .fetch()
      return chain
    }
  }
}
